import { render } from "./TerminalPage.vue?vue&type=template&id=5b072f40&scoped=true&ts=true"
import script from "./TerminalPage.vue?vue&type=script&lang=ts"
export * from "./TerminalPage.vue?vue&type=script&lang=ts"

import "./TerminalPage.vue?vue&type=style&index=0&id=5b072f40&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\lexoh-parking-ionic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b072f40"]])

export default __exports__